import React__default, { useContext } from "react";
import classNames from "classnames";
import { D as DataContext } from "./context4.js";
const defaultProps = {
  direction: "horizontal"
};
const SwiperItem = React__default.forwardRef((props, ref) => {
  const classPrefix = "nut-swiper-item";
  const _props = Object.assign(Object.assign({}, defaultProps), props);
  const { className, style, children, direction, size } = _props;
  const parent = useContext(DataContext);
  const classes = classNames(classPrefix, className);
  const getStyle = () => {
    const style2 = {};
    const _direction = (parent === null || parent === void 0 ? void 0 : parent.propSwiper.direction) || direction;
    const _size = (parent === null || parent === void 0 ? void 0 : parent.size) || size;
    if (_size) {
      style2[_direction === "horizontal" ? "width" : "height"] = `${_size}px`;
    }
    return style2;
  };
  return React__default.createElement("div", { className: classes, style: Object.assign(Object.assign({}, style), getStyle()) }, children);
});
SwiperItem.defaultProps = defaultProps;
SwiperItem.displayName = "NutSwiperItem";
export {
  SwiperItem as default
};
